<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="table.query.type" @tab-click="search(true, true)">
          <el-tab-pane label="装修成本" name="0"></el-tab-pane>
          <el-tab-pane label="日常开支" name="3"></el-tab-pane>
        </el-tabs>
        <div class="lr between">
          <div style="display: flex;justify-content: space-between;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)" style="width: 220px;"/>
            <el-date-picker
              v-if="table.query.type == 3"
              v-model="dates"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="search(true)"
              class="ml20"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-end;" v-if="table.query.type == 0">
            <el-button type="primary" size="small" @click="openFeeDataDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
            <el-button type="primary" size="small" @click="openItemDialog"
                       icon="el-icon-plus" v-if="isAdmin">装修项目
            </el-button>
            <el-button type="primary" size="small" @click="handleExcelExport"
                       icon="el-icon-download" class="ml20">导出
            </el-button>
          </div>
          <div style="display: flex;justify-content: flex-end;" v-if="table.query.type == 3">
            <el-button type="primary" size="small" @click="handleExcelExportDay"
                       icon="el-icon-download" class="ml20">导出
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border v-if="showTable"
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName" v-if="table.query.type == 0"></el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="createName" v-if="table.query.type == 3"></el-table-column>
            <el-table-column show-overflow-tooltip label="费用名称" align="center"
                             prop="name">
              <template slot-scope="scope">
                <span v-if="table.query.type == 0">总成本</span>
                <span v-else>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="费用" align="center"
                             prop="fee"></el-table-column>
            <el-table-column show-overflow-tooltip label="日期" align="center"
                             prop="happenDate" v-if="table.query.type == 3"></el-table-column>
            <el-table-column show-overflow-tooltip label="图片" align="center"
                             prop="happenDate" v-if="table.query.type == 3">
              <template slot-scope="scope">
                <div v-if="scope.row.imageUrls">
                  <img @click="openImageDialog(item)" v-for="(item, index) in scope.row.imageUrls.split(',')" :key="index" :src="item" style="width: 50px;height: 50px;cursor: pointer;" >
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="160" align="center" v-if="table.query.type == 0">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row)">明细</el-button>
                <el-button type="text" @click="openFeeDialog(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="itemDialog.visible" :close-on-click-modal="false" width="40%"
               title="装修项目">
      <renovation-item></renovation-item>
    </el-dialog>
    <el-dialog :visible.sync="detailDialog.visible" :close-on-click-modal="false" width="40%"
               title="装修明细">
      <fee-item :house-id="houseId" :house-name="houseName"></fee-item>
    </el-dialog>
    <el-dialog :visible.sync="feeDialog.visible" :close-on-click-modal="false" width="40%"
               title="编辑费用">
      <el-form ref="feeForm" label-position="right" label-width="120px" :model="feeDialog.formData"
               :rules="rules">
        <el-form-item label="房源：" prop="houseId">
          <el-select filterable  v-model="feeDialog.formData.houseId" placeholder="请选择房源" clearable style="width: 100%;">
            <el-option v-for="item in houses" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用：" prop="fee">
          <el-input placeholder="请输入费用" v-model="feeDialog.formData.fee" clearable/>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="feeDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="feeDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imageDialog.visible" :close-on-click-modal="false" width="40%"
               title="查看图片">
      <div style="display: flex;justify-content: center;align-items: center;">
        <img :src="imageDialog.url" style="width: 50%;height: 50%;">
      </div>
      <div class="dialog-btn">
        <el-button type="primary" @click="download(imageDialog.url)">下载</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="feeDataDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增装修成本' : '编辑装修成本'">
      <el-form ref="feeDataForm" label-position="right" label-width="120px" :model="feeDataDialog.formData"
               :rules="dataRules">
        <el-form-item label="房源：" prop="houseId">
          <el-select filterable  v-model="feeDataDialog.formData.houseId" placeholder="请选择房源" clearable style="width: 100%;">
            <el-option v-for="item in houses" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用项目：" prop="itemId">
          <el-select filterable  v-model="feeDataDialog.formData.itemId" placeholder="请选择费用项目" clearable style="width: 100%;">
            <el-option v-for="item in items" :key="item.id" :value="item.id"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用：" prop="fee">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="feeDataDialog.formData.fee"
                           clearable/>
        </el-form-item>
        <el-form-item label="录入人：" prop="createId">
          <el-select filterable  v-model="feeDataDialog.formData.createId" placeholder="请选择录入人" clearable style="width: 100%;">
            <el-option v-for="item in persons" :key="item.id" :value="item.id"
                       :label="item.nickname"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="feeDataDialog.formData.description"></el-input>
        </el-form-item>
        <el-form-item label="排序值：" prop="sort">
          <el-input-number style="width: 100%;" :min="0" :step="1" v-model="feeDataDialog.formData.sort"/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="feeDataDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateFeeData" :loading="dataLoading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getList, saveOrUpdateData} from "@/api/fee";
import {getAll as getPersons} from "@/api/user";
import RenovationItem from "@/components/RenovationItem";
import FeeItem from "@/components/FeeItem";
import {getList as getHouses} from "@/api/house";

export default {
  components: {
    RenovationItem,
    FeeItem
  },
  data() {
    return {
      table: {
        query: {
          keyWord: '',
          startDate: '',
          endDate: '',
          type: ''
        },
        total: 0,
        data: []
      },
      tableLoading: false,
      userInfo: {},
      isAdmin: false,
      itemDialog: {
        visible: false
      },
      detailDialog: {
        visible: false,
        data: []
      },
      dates: [],
      showTable: true,
      loading: false,
      feeDialog: {
        visible: false,
        formData: {
          houseId: '',
          houseName: '',
          description: '',
          fee: 0
        }
      },
      rules: {
        houseId: [
          {trigger: 'change', required: true, message: '请选择房源'}
        ],
        fee: [
          {trigger: 'blur', required: true, message: '请输入价格'}
        ]
      },
      houses: [],
      houseId: '',
      houseName: '',
      imageDialog: {
        visible: false,
        url: ''
      },
      isEdit: false,
      feeDataDialog: {
        formData: {
          houseId: '',
          houseName: '',
          rentRecordIds: '',
          rentRecordNames: '',
          name: '',
          itemId: '',
          fee: 0,
          type: 0,
          description: '',
          createId: '',
          createName: '',
          sort: 0
        },
        visible: false
      },
      dataRules: {
        houseId: [
          {trigger: 'change', required: true, message: '请选择房源'}
        ],
        rentRecordIds: [
          {trigger: 'change', required: true, message: '请选择出租记录'}
        ],
        itemId: [
          {trigger: 'blur', required: true, message: '请选择费用项目'}
        ],
        fee: [
          {trigger: 'blur', required: true, message: '请输入费用'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ],
        createId: [
          {trigger: 'blur', required: true, message: '请选择录入人'}
        ]
      },
      dataLoading: false,
      items: [],
      persons: []
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.isAdmin = this.userInfo.roleIds.indexOf('1') != -1
    this.search(true)
    this.getHouses()
    this.getPersons()
    this.getItems()
  },
  methods: {
    getPersons() {
      getPersons().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.persons = response.data.filter(item => item.roleIds == 2)
        }
      })
    },
    getItems() {
      const params = {
        type: 4
      }
      getList(params).then(response => {
        if (response.code == 200) {
          this.items = response.data
        }
      })
    },
    saveOrUpdateFeeData() {
      this.dataLoading = true
      this.$refs['feeDataForm'].validate(async (valid) => {
        if (valid) {
          this.feeDataDialog.formData.type = 0
          this.feeDataDialog.formData.houseName = this.houses.filter(item => item.id == this.feeDataDialog.formData.houseId)[0].name
          this.feeDataDialog.formData.name = this.items.filter(item => item.id == this.feeDataDialog.formData.itemId)[0].name
          this.feeDataDialog.formData.createName = this.persons.filter(item => item.id == this.feeDataDialog.formData.createId)[0].nickname
          saveOrUpdateData(this.feeDataDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.feeDataDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.dataLoading = false
          })
        } else {
          this.dataLoading = false
        }
      })
    },
    openFeeDataDialog(data, isEdit) {
      this.isEdit = isEdit
      if (!isEdit) {
        // 重置数据
        this.feeDataDialog.formData = {
          houseId: '',
          houseName: '',
          rentRecordIds: '',
          rentRecordNames: '',
          feeIds: '',
          feeNames: '',
          name: '',
          agencyFee: 0,
          fee: 0,
          type: 0,
          description: '',
          createId: '',
          createName: '',
          sort: 0
        }
      } else {
        this.feeDataDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.feeDataDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.feeDataForm.clearValidate()
      })
    },
    getHouses() {
      getHouses().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.houses = response.data
        }
      })
    },
    // 搜索框查询
    search(flag, changeTab) {
      this.tableLoading = true
      if (this.dates && this.dates.length > 0) {
        this.table.query.startDate = this.dates[0]
        this.table.query.endDate = this.dates[1]
      } else {
        this.table.query.startDate = ''
        this.table.query.endDate = ''
      }
      const params = {
        keyWord: this.table.query.keyWord,
        type: this.table.query.type,
        statistics: this.table.query.type == 0 ? true : false,
        startDate: this.table.query.startDate,
        endDate: this.table.query.endDate
      }
      if (changeTab) {
        this.showTable = false
      }
      getList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        if (changeTab) {
          this.showTable = true
        }
        this.tableLoading = false

      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    handleExcelExport() {
      window.open("/hrApi/fee/export?type=0&statistics=true&token=" + localStorage.getItem("token"));
      this.$message.success("导出成功！");
    },
    handleExcelExportDay() {
      let url = "/hrApi/fee/export?type=3&statistics=false&token=" + localStorage.getItem("token");
      if (this.dates.length > 0) {
        url = url + "&startDate=" + this.dates[0]
        url = url + "&endDate=" + this.dates[1]
      }
      window.open(url);
      this.$message.success("导出成功！");
    },
    openDialog(row) {
      this.houseId = row.houseId
      this.houseName = row.houseName
      this.detailDialog.visible = true
    },
    openItemDialog() {
      this.itemDialog.visible = true
    },
    // 修改房源
    saveOrUpdateData() {
      this.loading = true
      this.$refs['feeForm'].validate(async (valid) => {
        if (valid) {
          this.feeDialog.formData.houseName = this.houses.filter(item => item.id == this.feeDialog.formData.houseId)[0].name
          saveOrUpdateData(this.feeDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.feeDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openFeeDialog(data) {
      this.feeDialog.formData = JSON.parse(JSON.stringify(data))
      this.feeDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.feeForm.clearValidate()
      })
    },
    openImageDialog(url) {
      this.imageDialog.url = url
      this.imageDialog.visible = true
    },
    download(url) {
      window.open(url);
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/feeOut.vue